import { Tile } from '#src/components/boards/HotStreakTile/Tile/index.tsx';
import { DiamondBaseColor } from '#src/components/boards/HotStreakTile/Tile/utils.ts';

export const ReadyTile = () => {
  return <Tile color={DiamondBaseColor.orange} borderAnimated scaling />;
};
